import rootReducer from "./root-reducer";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REGISTER,
  REHYDRATE,
  PAUSE,
  PURGE,
  PERSIST,
} from "redux-persist";
import { configureStore } from "@reduxjs/toolkit";
import localStorage from "redux-persist/lib/storage"; 
import sessionStorage from "redux-persist/lib/storage/session";
const is_web_view = typeof window !== 'undefined' && (window.Android);
const storage = is_web_view ? sessionStorage : localStorage;
const persistConfig = {
  key: "root",
  storage,
};

const configureStores = () => {
  const store = configureStore({
    reducer: persistReducer(persistConfig, rootReducer),
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REGISTER, REHYDRATE, PAUSE, PURGE, PERSIST],
        },
      }),
  });
  let persistor = persistStore(store);
  window.store = store;
  return { store, persistor };
};

export default configureStores;
